import { format } from 'date-fns'

import { ProductCardsType, ProductsApiStats } from '~/redux/apis/user-stats-api'
import { PRODUCT_CARD_NOT_APPLICABLE_DATE } from '~/statistics/constants'

interface ReturnType {
  [date: string]: ProductCardsType[]
}

export function groupProductDataByDate(productStats: ProductsApiStats | undefined): ReturnType {
  const map = new Map()

  productStats?.forEach((product: ProductCardsType) => {
    if (product?.lastVisited) {
      const lastVisitedDate =
        product.lastVisited != null
          ? format(new Date(product.lastVisited), 'yyyy-MM-dd')
          : PRODUCT_CARD_NOT_APPLICABLE_DATE

      if (map.has(lastVisitedDate)) {
        map.set(lastVisitedDate, [...map.get(lastVisitedDate), product])
      } else {
        map.set(lastVisitedDate, [product])
      }
    }
  })

  return Object.fromEntries(
    [...map.entries()]
      .sort((a, b) => new Date(b[0]).getTime() - new Date(a[0]).getTime())
      .map(([date, products]) => [
        date,
        products.sort(
          (a: ProductCardsType, b: ProductCardsType) =>
            new Date(b.lastVisited).getTime() - new Date(a.lastVisited).getTime(),
        ),
      ]),
  )
}
